export function deviceOs(device = {}) {
  const platform = String(device.osPlatform || "").toLowerCase()
  if (platform === "linux" || platform === "macos" || platform === "windows") {
    return platform
  }
  const category = String(device.deviceCategory || "").toLowerCase()
  if (category === "linux") return "linux"
  if (category === "mac") return "macos"
  const name = [
    device.osName,
    device.sysInfo?.["OS Name"],
    device.sysInfo?.OS,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
  if (/macos|darwin|\bos x\b/.test(name)) return "macos"
  if (/\blinux\b|ubuntu|debian|rhel|centos|fedora|suse|rocky|alma/.test(name)) {
    return "linux"
  }
  return "windows"
}

export function isUnixDevice(device = {}) {
  const os = deviceOs(device)
  return os === "linux" || os === "macos"
}

/** Windows Server SKUs do not support System Restore points. */
export function isWindowsServerDevice(device = {}) {
  if (isUnixDevice(device)) return false
  const name = [
    device.osName,
    device.sysInfo?.["OS Name"],
    device.sysInfo?.OS,
    device.sysInfo?.Caption,
  ]
    .filter(Boolean)
    .join(" ")
  return /\bserver\b/i.test(name)
}

export function osUpdateLabel(device = {}) {
  const os = deviceOs(device)
  if (os === "linux") return "Linux updates"
  if (os === "macos") return "macOS updates"
  return "Windows updates"
}

export function osUpdateNoun(device = {}, count = 0) {
  const os = deviceOs(device)
  if (os === "linux") return count === 1 ? "Linux update" : "Linux updates"
  if (os === "macos") return count === 1 ? "macOS update" : "macOS updates"
  return count === 1 ? "Windows update" : "Windows updates"
}

/** Short OS label for dense inventory tables. */
export function compactOsLabel(device = {}) {
  const raw =
    device.osName ||
    device.sysInfo?.["OS Name"] ||
    device.sysInfo?.OS ||
    ""
  const name = String(raw).trim()
  const version =
    device.sysInfo?.["OS Version"] ||
    device.sysInfo?.["OS BuildNumber"] ||
    device.osVersion ||
    ""
  const build = String(version).trim()

  if (!name) {
    const platform = deviceOs(device)
    if (platform === "macos") return { label: "macOS", detail: build || "—" }
    if (platform === "linux") return { label: "Linux", detail: build || "—" }
    return { label: "Windows", detail: build || "—" }
  }

  let label = name
    .replace(/^microsoft\s+/i, "")
    .replace(/\bprofessional\b/i, "Pro")
    .replace(/\benterprise\b/i, "Ent")
    .replace(/\bhome\b/i, "Home")
    .replace(/\s+/g, " ")
    .trim()

  if (/windows\s*11/i.test(label)) label = label.replace(/windows\s*11.*/i, "Windows 11").trim()
  else if (/windows\s*10/i.test(label)) label = label.replace(/windows\s*10.*/i, "Windows 10").trim()
  else if (/windows\s*server/i.test(label)) {
    const m = label.match(/windows\s*server\s*(\d{4})?/i)
    label = m?.[1] ? `Server ${m[1]}` : "Windows Server"
  } else if (/macos|mac os/i.test(label)) label = "macOS"
  else if (label.length > 22) label = `${label.slice(0, 20)}…`

  return { label, detail: build || "—" }
}
